import { defineNuxtPlugin } from '@nuxtjs/composition-api'
import Vue from 'vue';
import Carousel3d from 'vue-carousel-3d';

export default defineNuxtPlugin(() => {
  Vue.use(Carousel3d)
})
